<a
  class="navigation-item mat-typography"
  [routerLink]="link"
  [ngClass]="{ 'navigation-item_round': !isExpanded }"
  routerLinkActive="navigation-item_active"
  (click)="preRedirect.emit()">
  <div>
    <mat-icon class="navigation-item__icon">{{ iconName }} </mat-icon>
    <span *ngIf="isExpanded">{{ title }}</span>
  </div>
</a>
